import * as Yup from 'yup';
import { CasesGeneralTypification } from '../../../../../../shared/types/modules/cases-general';

export const initialValues: CasesGeneralTypification = {
    typification1: '',
    typification2: '',
};

export const validationSchema = Yup.object({
    typification1: Yup.string().required('La tipificación 1 es obligatoria'),
    typification2: Yup.string().required('La tipificación 2 es obligatoria'),
});
